const masks = {
  cpf: '###.###.###-##',
  cnpj: '##.###.###/####-##',
  postalcode: '#####-###',
  phone: '(##)####-####',
  cellphone: '(##)#####-####',
  rg: '######-#',
};

export default masks;



// WEBPACK FOOTER //
// ./src/mixins/masks.js